(function () {
    'use strict';

    angular.module('swif.reservations')
    .component('reservationRequestForm', {
        templateUrl: 'partials/openresa/components/reservation_request_form.html',
        controller: reservationRequestFormController,
        bindings: {
            model: '='
        }
    });

    function reservationRequestFormController($q, $scope, $element, swif, openresa, dataService, swifOpenbaseCompanyService) {
        'ngInject';
        var $ctrl = this;
        $ctrl.$onInit = onInit;
        $ctrl.deleteRequester = deleteRequester;
        $ctrl.expand = expand;
        $ctrl.addNewBooking = addNewBooking;
        $ctrl.setActiveBooking = setActiveBooking;
        $ctrl.setAllBookings = setAllBookings;
        $ctrl.removeBooking = removeBooking;
        $ctrl.removeRecurrence = removeRecurrence;

        $ctrl.recurrenceParser = {};
        $ctrl.recurrenceIsRequired = false;
        $ctrl.invalidDates = true;
        $ctrl.recurrenceParser.updateDates = updateDates;
        $ctrl.recurrenceParser.activateRecurrence = activateRecurrence;
        $ctrl.recurrenceParser.deactivateRecurrence = deactivateRecurrence;

        $ctrl.onChangeIsCitizen = onChangeIsCitizen;
        $ctrl.onChangePartnerAddress = onChangePartnerAddress;
        $ctrl.onChangePartner = onChangePartner;
        $ctrl.onChangeCategory = onChangeCategory;
        $ctrl.onChangeName = onChangeName;
        $ctrl.onChangeNote = onChangeNote;
        $ctrl.onChangeRecurrenceState = onChangeRecurrenceState;
        $ctrl.onChangeBookingDates = onChangeBookingDates;
        $ctrl.allDatesOk = true;

        function onInit () {
            $ctrl.model = openresa.requests.init($ctrl.model || {});
            $ctrl.filters = {};
            $ctrl.loading = {};
            $ctrl.rights = openresa.rights.getUserAbility();
            $ctrl.defaultTab = 0;
            $ctrl.categoryFilter = { fields: ['id', 'name', 'description'] };
            $ctrl.currentCategoryDescription = '';

            // check if the name and category label are the same
            $ctrl.categoryNameSync = isCategoryNameSync();
            // check if the note and category description are the same
            $ctrl.categoryDescriptionSync = isCategoryDescriptionSync();
            // compute 'readonly'
            $ctrl.readonly = Boolean($ctrl.model._readonly);
            // get filters for form widgets
            $ctrl.filters = openresa.requests.getFilters($ctrl.model);
            // fetch existing records or create an empty one
            if ($ctrl.model.id) {
                $ctrl.defaultTab = 2;
                swif.message.loading($ctrl.loading);
                openresa.requests.fetch($ctrl.model).then(function () {
                    // compute booking.recurrence values
                    openresa.requests.linkRecurrenteBookings($ctrl.model);
                    /* _.forEach($ctrl.model.recurrences, function (recurrence) {
                        openresa.recurrences.computeLastDate($ctrl.model, recurrence);
                    }); */
                    // activate the 1st booking found
                    $ctrl.setActiveBooking();

                    //TG3727 - As other bookings were not loaded, general changes were not saved for them. We now load them all
                    $ctrl.setAllBookings();
                    openresa.requests.fetchSlowFields($ctrl.model)
                    .then(onSuccess, onError);
                });
            } else {
                if (!$ctrl.rights.is.manager && !$ctrl.rights.is.agent) {
                    $ctrl.defaultTab = 1;
                }
                if ($ctrl.model.bookings.length === 0 && $ctrl.model.recurrences.length === 0) {
                    $ctrl.addNewBooking();
                } else {
                    $ctrl.setActiveBooking();
                }
            }
        }

        function onSuccess () {
            swif.message.loading($ctrl.loading, 'ok');
        }

        function onError () {
            swif.message.loading($ctrl.loading, 'ko');
        }

        function isCategoryNameSync () {
            var categ = $ctrl.model.booking_type_id;
            var categName = categ ? categ[1]: '';
            return $ctrl.model.name === categName;
        }

        function isCategoryDescriptionSync () {
            var currentCategDesc = $ctrl.currentCategoryDescription;
            return $ctrl.model.note === undefined ? true : $ctrl.model.note === currentCategDesc;
        }

        function expand (active) {
            $ctrl.expanded = Boolean(active);
            if (active) {
                $element.parents('.modal-dialog:first').addClass('modal-extra-large');
            } else {
                $element.parents('.modal-dialog:first').removeClass('modal-extra-large');
            }
        }

        function addNewBooking () {
            var newModel = openresa.bookings.init(newModel);
            if ($ctrl.model._selectedBooking) {
                var lines = angular.copy($ctrl.model._selectedBooking.lines);
                _.forEach(lines, function (line) {
                    delete line.id;
                    delete line.booking_id;
                    newModel.lines.push(line);
                });
            }

            $ctrl.model.bookings.splice(0, 0, newModel);
            $ctrl.setActiveBooking(newModel);
        }

        function hasActiveBooking () {
            var active = $ctrl.model._selectedBooking;
            var b = $ctrl.model.bookings;
            var r = $ctrl.model.recurrences;
            return active && (_.contains(b, active) || _.contains(r, active));
        }

        function setActiveBooking (booking) {
            // decides which booking must be activated (selected or first one)
            if (!booking) {
                // find the first element found on bookings or on recurrences
                booking = $ctrl.model.bookings[0] || $ctrl.model.recurrences[0];
            }
            if (booking) {
                var srv = openresa.bookings;
                if (booking._type === 'recurrenteReservation') {
                    srv = openresa.recurrences;
                }
                $ctrl.model._selectedBooking = srv.init(booking);
                if (booking.id && !booking.fetched) {
                    srv.fetch($ctrl.model._selectedBooking);
                    // if(booking.totalDiscountPercent === undefined || booking.totalDiscountPercent == 0){
                    //     booking.totalDiscountPercent = (booking.dailyTotal - booking.dailyTotalDiscount) / booking.dailyTotal * 100;
                    //     booking.totalDiscountPercent = Math.round(booking.totalDiscountPercent * 100) / 100;
                    // }
                }
            } else {
                $ctrl.model._selectedBooking = undefined;
            }
            if ($ctrl.model.bookings) {
                let allOk = true;
                for (const bkg of $ctrl.model.bookings) {
                    if (bkg != booking && !bkg.all_dispo) {
                        allOk = false;
                    }
                }
                $ctrl.allDatesOk = allOk;
            }
        }

        function setAllBookings (bookings) {
            // decides which booking must be activated (selected or first one)
            if (!bookings) {
                bookings = $ctrl.model.bookings || $ctrl.model.recurrences;
            }
            if (bookings) {
                _.forEach(bookings, function (booking) {
                    var srv = openresa.bookings;
                    if (bookings._type === 'recurrenteReservation') {
                        srv = openresa.recurrences;
                    }
                    if (booking.id && !booking.fetched) {
                        srv.fetch(booking);
                    }
                });
            }
        }

        /*
         * @param request: object to remove the booking
         * @param booking: item to remove
        */
        function removeBooking (booking) {
            var bookingsToDelete = _.remove($ctrl.model.bookings, function (item) {
                return item === booking;
            });
            _.forEach(bookingsToDelete, function (item) {
                if (item.id) {
                    $ctrl.model.deletedBookings.push(item);
                }
            });
            if (booking.recurrence) {
                openresa.recurrences.computeLastDate($ctrl.model, booking.recurrence);
            }
            if (!hasActiveBooking()) {
                $ctrl.setActiveBooking();
            }
        }

        function removeRecurrence (recurrence) {
            openresa.recurrences.removeRecurrence($ctrl.model, recurrence);
            if (!hasActiveBooking()) {
                $ctrl.setActiveBooking();
            }
        }

        function updateDates (recurrence) {
            swif.message.loading($ctrl.loading);
            return openresa.recurrences.getDates($ctrl.model, recurrence)
            .then(function (occurrences) {
                if (recurrence._occurrencesState) {
                    _.forEach(occurrences, function (occurrence) {
                        occurrence.state = recurrence._occurrencesState;
                    });
                }
                onSuccess();
                $ctrl.recurrenceIsRequired=false;
            }, onError);
        }

        // used to initialize the recurrence setting on the current model
        // it will move the current object from the bookings to the recurrences list
        function activateRecurrence (model) {
            if (model._type !== 'recurrenteReservation') {
                $ctrl.recurrenceIsRequired=true;
                //recurrence is valid only after dates generation
                $ctrl.removeBooking(model);
                var newModel = openresa.recurrences.fromBookingToRecurrence(model);
                newModel._occurrencesState = model.state || false;
                $ctrl.model.recurrences.push(newModel);
                $ctrl.setActiveBooking(newModel);
            }
        }

        // used to remove the recurrence setting and geneated occurrences
        // by clicking on the button 'remove recurrence'
        // it will move the current object from the recurrences to the bookings list
        function deactivateRecurrence (model) {
            if (model._type === 'recurrenteReservation') {
                openresa.recurrences.removeRecurrence($ctrl.model, model);
                var newModel = openresa.recurrences.fromRecurrenceToBooking(model);
                newModel.state = model._occurrencesState || false;
                $ctrl.model.bookings.push(newModel);
                $ctrl.setActiveBooking(newModel);
                $ctrl.recurrenceIsRequired=false;
            }
        }

        function onChangeIsCitizen (is_citizen) {
            $ctrl.filters = openresa.requests.getFilters($ctrl.model);
        }

        function updatePrices(request){
            var model = request.bookings[0];
            _.forEach(model.lines, function (line) {
                if(request.partner_id) {
                    var partnerId = request.partner_id[0];
                    if (model.checkin && model.checkout && partnerId) {
                        dataService.callKw('partner',
                            'get_bookable_prices',
                            [
                                partnerId,
                                [{prod_id: line.resource.id, qty: line.qty}],
                                model.checkin,
                                model.checkout
                            ],
                            {}).then(function (data) {
                                line.pricelist_amount = data[line.resource.id] || 0;
                            }
                        );
                    }
                }
            });
        }

        function deleteRequester () {
            delete $ctrl.model.partner_invoice_id;
            delete $ctrl.model.partner_id;
            $ctrl.onChangePartnerAddress({});
            $ctrl.onChangePartner({});
        }

        //change partner_id inside each booking $ctrl.model.bookings
        function changePartnerInBookings (partner) {
            _.forEach($ctrl.model.bookings, function (booking) {
                if (booking){
                    booking.partner_id = partner;
                }
            });
        }

        function onChangePartnerAddress (partner) {
            $ctrl.model.partner_id = partner.partner_id || false;
            $ctrl.filters = openresa.requests.getFilters($ctrl.model);
            changePartnerInBookings($ctrl.model.partner_id);
            updatePrices($ctrl.model);
        }

        function onChangePartner (partner) {
            $ctrl.filters = openresa.requests.getFilters($ctrl.model);
            changePartnerInBookings($ctrl.model.partner_id);
            updatePrices($ctrl.model);
        }

        function onChangeCategory (categ) {
            $ctrl.currentCategoryDescription = categ.description;
            if ($ctrl.categoryNameSync) {
                $ctrl.model.name = categ.name || '';
            } else {
                $ctrl.categoryNameSync = isCategoryNameSync();
            }
            if ($ctrl.categoryDescriptionSync) {
                $ctrl.model.note = categ.description || '';
            } else {
                $ctrl.categoryDescriptionSync = isCategoryDescriptionSync();
            }
        }

        function onChangeName (name) {
            $ctrl.categoryNameSync = isCategoryNameSync();
        }

        function onChangeNote(desc) {
            $ctrl.categoryDescriptionSync = isCategoryDescriptionSync();
        }

        function onChangeRecurrenceState (recurrence) {
            if (recurrence._occurrencesState) {
                _.forEach($ctrl.model.bookings, function (elt) {
                    if (elt.recurrence === recurrence) {
                        elt.state = recurrence._occurrencesState;
                    }
                });
            }
        }

        function onChangeBookingDates (booking, checkin, checkout) {
            if (checkin && checkout && booking.recurrence) {
                openresa.recurrences.computeLastDate($ctrl.model, booking.recurrence);
            }
        }

        $scope.$watchGroup(['$ctrl.model._selectedBooking.checkin', '$ctrl.model._selectedBooking.checkout'], function(nv) {
            var checkin = nv[0];
            var checkout = nv[1];
            if (checkin != undefined && checkout != undefined) {
                $ctrl.invalidDates = false;
            } else {
                $ctrl.invalidDates = true;
            }
        });
    }

})();
